module.exports = __webpack_public_path__ + "static/img/data.52ceeff2.gif";